import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "dailiipshezhi"
};
const _hoisted_2 = {
  class: "panel-title"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("新增代理ip");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("返回");

const _hoisted_5 = {
  class: "panel-body"
};
const _hoisted_6 = {
  style: {
    "text-align": "left",
    "max-height": "100px",
    "overflow": "auto"
  }
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "myform"
};

const _hoisted_10 = /*#__PURE__*/_createTextVNode("用户名");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("ip地址");

const _hoisted_12 = /*#__PURE__*/_createTextVNode("全部删除");

const _hoisted_13 = /*#__PURE__*/_createTextVNode("随机排列");

const _hoisted_14 = /*#__PURE__*/_createTextVNode("+增加单个");

const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "-", -1);

const _hoisted_16 = /*#__PURE__*/_createTextVNode("+增加起始段ip");

const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, "起始段为后两段区间，如：1.1.1.1-1.1.2.255", -1);

const _hoisted_18 = /*#__PURE__*/_createTextVNode("备注");

const _hoisted_19 = {
  key: 0,
  style: {
    "margin-top": "10px"
  }
};

const _hoisted_20 = /*#__PURE__*/_createTextVNode("取 消");

const _hoisted_21 = /*#__PURE__*/_createTextVNode("确 定");

const _hoisted_22 = {
  key: 1,
  style: {
    "margin-top": "10px"
  }
};

const _hoisted_23 = /*#__PURE__*/_createTextVNode("取 消");

const _hoisted_24 = /*#__PURE__*/_createTextVNode("确 定");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");

  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_col = _resolveComponent("el-col");

  const _component_el_row = _resolveComponent("el-row");

  const _component_el_button_group = _resolveComponent("el-button-group");

  const _component_el_table = _resolveComponent("el-table");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_tag = _resolveComponent("el-tag");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "panel",
    style: _normalizeStyle({
      width: $data.title == '代理ip设置' ? '100%' : '1200px'
    })
  }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h2", null, _toDisplayString($data.title), 1), $data.title == '代理ip设置' ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    style: {
      "float": "right"
    },
    type: "primary",
    size: "small",
    onClick: $options.add
  }, {
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  }, 8, ["onClick"])) : (_openBlock(), _createBlock(_component_el_button, {
    key: 1,
    style: {
      "float": "right",
      "margin-top": "3px"
    },
    size: "small",
    type: "warning",
    onClick: $options.cancel_add
  }, {
    default: _withCtx(() => [_hoisted_4]),
    _: 1
  }, 8, ["onClick"]))]), _createElementVNode("div", _hoisted_5, [$data.title == '代理ip设置' ? (_openBlock(), _createBlock(_component_el_table, {
    key: 0,
    data: $data.list,
    border: "",
    size: "small",
    "highlight-current-row": "",
    "header-cell-class-name": "table-header-cell",
    "header-row-class-name": "table-header-row",
    "table-layout": "auto"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "username",
      label: "用户",
      align: "center",
      width: "100px"
    }), _createVNode(_component_el_table_column, {
      prop: "ips",
      label: "IP",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_row, {
        gutter: 2,
        style: {
          "text-align": "left",
          "max-height": "100px",
          "overflow": "auto"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.ips, item => {
          return _openBlock(), _createBlock(_component_el_col, {
            span: 3,
            key: item
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 2
      }, 1024)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "remark",
      label: "备注",
      align: "center",
      width: "100px"
    }, {
      default: _withCtx(scope => [_createElementVNode("div", _hoisted_6, _toDisplayString(scope.row.remark), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "b_rate",
      label: "功能",
      align: "center",
      width: "100px"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_button_group, null, {
        default: _withCtx(() => [_createElementVNode("a", {
          class: "a-icon i-changeLog theme-text",
          style: {
            "margin-right": "0"
          },
          href: "#",
          onClick: _withModifiers($event => $options.change_ip(scope.row), ["prevent"])
        }, "修改", 8, _hoisted_7), _createElementVNode("a", {
          class: "a-icon i-cashOut theme-text",
          style: {
            "margin-right": "0"
          },
          href: "#",
          onClick: _withModifiers($event => $options.del(scope.row.id), ["prevent"])
        }, "删除", 8, _hoisted_8)]),
        _: 2
      }, 1024)]),
      _: 1
    })]),
    _: 1
  }, 8, ["data"])) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_10]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        style: {
          "width": "200px"
        },
        size: "small",
        modelValue: $data.dialog.username,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.dialog.username = $event),
        placeholder: "请输入用户名",
        disabled: $data.title == '修改代理ip'
      }, null, 8, ["modelValue", "disabled"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_11]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        gutter: 10,
        style: {
          "max-height": "100px",
          "overflow": "auto"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dialog.ips, (item, index) => {
          return _openBlock(), _createBlock(_component_el_col, {
            span: 4,
            key: index,
            style: {
              "margin": "2px 0"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tag, {
              closable: "",
              "disable-transitions": false,
              onClose: $event => $options.handleClose(index)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.text), 1)]),
              _: 2
            }, 1032, ["onClose"])]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }), _createVNode(_component_el_row, {
        gutter: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createTextVNode("当前总计已填写：" + _toDisplayString($data.dialog.ips.length) + " 个ip", 1)]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [$data.dialog.ips.length > 0 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            size: "small",
            type: "info",
            plain: "",
            onClick: _cache[1] || (_cache[1] = $event => $data.dialog.ips = [])
          }, {
            default: _withCtx(() => [_hoisted_12]),
            _: 1
          })) : _createCommentVNode("", true), $data.dialog.ips.length > 1 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            size: "small",
            type: "warning",
            plain: "",
            onClick: $options.shuffle
          }, {
            default: _withCtx(() => [_hoisted_13]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            size: "small",
            placeholder: "请输入代理ip",
            modelValue: $data.dialog.dip,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.dialog.dip = $event),
            clearable: "",
            style: {
              "width": "150px"
            }
          }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
            type: "success",
            size: "small",
            onClick: $options.add_ip
          }, {
            default: _withCtx(() => [_hoisted_14]),
            _: 1
          }, 8, ["onClick"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            size: "small",
            placeholder: "请输入开始ip",
            modelValue: $data.dialog.qip,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.dialog.qip = $event),
            clearable: "",
            style: {
              "width": "150px"
            }
          }, null, 8, ["modelValue"]), _hoisted_15, _createVNode(_component_el_input, {
            size: "small",
            placeholder: "请输入结束ip",
            modelValue: $data.dialog.sip,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.dialog.sip = $event),
            clearable: "",
            style: {
              "width": "150px"
            }
          }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
            type: "success",
            size: "small",
            onClick: $options.add_ip_qs
          }, {
            default: _withCtx(() => [_hoisted_16]),
            _: 1
          }, 8, ["onClick"]), _hoisted_17]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_18]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        style: {
          "margin": "5px 0"
        },
        size: "small",
        type: "textarea",
        modelValue: $data.dialog.remark,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.dialog.remark = $event),
        placeholder: "请输入内容",
        autosize: {
          minRows: 3,
          maxRows: 6
        }
      }, null, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  })]), $data.title == '新增代理ip' ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_el_button, {
    size: "small",
    onClick: $options.cancel_add
  }, {
    default: _withCtx(() => [_hoisted_20]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    size: "small",
    type: "primary",
    onClick: $options.sub_add
  }, {
    default: _withCtx(() => [_hoisted_21]),
    _: 1
  }, 8, ["onClick"])])) : (_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(_component_el_button, {
    size: "small",
    onClick: $options.cancel_add
  }, {
    default: _withCtx(() => [_hoisted_23]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    size: "small",
    type: "primary",
    onClick: $options.sub_change
  }, {
    default: _withCtx(() => [_hoisted_24]),
    _: 1
  }, 8, ["onClick"])]))], 64))])], 4)]);
}